const STORAGE_KEY = "flashAfterNavigation"

interface PendingFlash {
  message: string
  type: string
}

export function navigateWithFlash(url: string, message: string, type = "success") {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ message, type }))
  } catch {
    // Storage can be unavailable (private browsing); the page still navigates, only the message is lost.
  }
  window.location.assign(url)
}

export function showFlashAfterNavigation() {
  let stored: string | null
  try {
    stored = window.sessionStorage.getItem(STORAGE_KEY)
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    return
  }
  if (!stored) return

  const { message, type } = JSON.parse(stored) as PendingFlash
  window.appendFlash(message, type)
}
